export default [

  {
    path: "/risk-taxonomy",
    name: "RiskTaxonomy",
    component: () => import("@/views/Page/RiskTaxonomy/RiskTaxonomy.vue"),
    meta: {
      title: "Risk Taxonomy",
    },
  }
];
